import { Button, Descriptions, Space, Tabs, Tag, Card, List } from "antd";
import { ArrowLeftOutlined, SendOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useKycQuestionnaireDetail } from "./useKycQuestionnaireDetail";

const questionTypeLabels: Record<string, string> = {
  SINGLE_CHOICE: "Нэг сонголтот",
  MULTIPLE_CHOICE: "Олон сонголтот",
  FREE_TEXT: "Чөлөөт текст",
  NUMBER: "Тоо",
  DATE: "Огноо",
  FILE_UPLOAD: "Файл хавсаргах",
};

export const KycQuestionnaireDetailWidget = ({ _id }: { _id: string }) => {
  const { data } = useKycQuestionnaireDetail({ _id });

  return (
    <>
      <div className="page-header">
        <h3>KYC Судалгаа дэлгэрэнгүй</h3>
        <Space>
          <Link to={`/kyc-questionnaires/send/${_id}`}>
            <Button type="primary" icon={<SendOutlined />}>
              Илгээх
            </Button>
          </Link>
          <Link to="/kyc-questionnaires">
            <Button type="dashed" icon={<ArrowLeftOutlined />}>
              Буцах
            </Button>
          </Link>
        </Space>
      </div>

      <Tabs defaultActiveKey="info" style={{ marginTop: 16 }}>
        <Tabs.TabPane tab="Мэдээлэл" key="info">
          {data && (
            <Descriptions
              bordered
              column={1}
              size="small"
              style={{ marginBottom: 24 }}
            >
              <Descriptions.Item label="Нэр (МН)">
                {data.localizedName?.mn ?? data.name ?? "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Нэр (EN)">
                {data.localizedName?.en ?? "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Тайлбар (МН)">
                {data.localizedDescription?.mn ?? data.description ?? "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Тайлбар (EN)">
                {data.localizedDescription?.en ?? "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Идэвхитэй">
                <Tag color={data.active ? "green" : "default"}>
                  {data.active ? "Тийм" : "Үгүй"}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="Асуултын тоо">
                {data.questions.length}
              </Descriptions.Item>
              <Descriptions.Item label="Үүсгэсэн огноо">
                {data.createdAt
                  ? new Date(data.createdAt).toLocaleString("mn-MN")
                  : "-"}
              </Descriptions.Item>
            </Descriptions>
          )}
        </Tabs.TabPane>

        <Tabs.TabPane
          tab={`Асуултууд (${data?.questions.length ?? 0})`}
          key="questions"
        >
          {data?.questions
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((q, idx) => (
              <Card
                key={q._id}
                size="small"
                style={{ marginBottom: 12 }}
                title={
                  <div>
                    <div>
                      <strong>{idx + 1}. МН:</strong>{" "}
                      {q.localizedQuestion?.mn ?? q.question}
                    </div>
                    <div style={{ color: "#555", fontWeight: 400 }}>
                      <strong>EN:</strong> {q.localizedQuestion?.en ?? "-"}
                    </div>
                  </div>
                }
                extra={
                  <Space>
                    <Tag color="blue">
                      {questionTypeLabels[q.type] ?? q.type}
                    </Tag>
                    {q.required && <Tag color="red">Заавал</Tag>}
                  </Space>
                }
              >
                {(q.type === "SINGLE_CHOICE" || q.type === "MULTIPLE_CHOICE") &&
                  q.options &&
                  q.options.length > 0 && (
                    <List
                      size="small"
                      bordered
                      dataSource={q.options}
                      renderItem={(opt, oIdx) => (
                        <List.Item>
                          <div style={{ width: "100%" }}>
                            <div>
                              <strong>{oIdx + 1}. МН:</strong>{" "}
                              {opt.localizedValue?.mn ?? opt.value}
                            </div>
                            <div style={{ color: "#555" }}>
                              <strong>EN:</strong>{" "}
                              {opt.localizedValue?.en ?? "-"}
                            </div>
                          </div>
                        </List.Item>
                      )}
                    />
                  )}
              </Card>
            ))}
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};
